import { css, html } from "../utils/template-literal-tags";
import "./shared/button-close";
import "./entry-timer";
import dayjs from "dayjs";

class EntryOngoing extends HTMLElement {
  #entry?: Entry;
  #tag?: Tag;

  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = html`
      <div class="content">
        <div class="start-time">${dayjs().format("HH:mm")}</div>
        <div class="tag-pill"></div>
        <div class="comment"></div>
        <div class="timer"></div>
        <div class="close"></div>
      </div>
    `;

    const savedEntry = this.#findSavedEntry();
    if (!this.#entry) return;

    this.render(savedEntry);
  }

  set entry(entry: Entry) {
    this.#entry = entry;
    this.#tag = entry.tags;
    this.#saveOngoingEntryToLs();
  }

  render(entry: Entry | undefined = this.#entry) {
    if (!entry) return;

    const timer = document.createElement("entry-timer");
    //@ts-ignore
    timer.setStartTime = entry.startTime;

    const btnClose = document.createElement("button-close");
    btnClose.addEventListener("click", async () => {
      const event = new CustomEvent<SubmitDataDetail>("submit-data", {
        bubbles: true,
        composed: true,
        detail: {
          endpoint: "/entries/end-entry",
          method: "POST",
          payload: {
            entry: { ...this.#entry },
          },
        },
      });

      this.dispatchEvent(event);

      // conditionally close widget based on response? and display error otherwise perhaps.
      this.#closeWidget();
    });

    this.querySelector(".timer")!.appendChild(timer);
    this.querySelector(".close")!.appendChild(btnClose);
    this.querySelector(".tag-pill")!.innerHTML = String(this.#tag);
    this.querySelector(".comment")!.textContent = String(entry.comment);
  }

  #closeWidget() {
    this.#clearSavedEntry();
    this.remove();
  }

  #saveOngoingEntryToLs() {
    if (!this.#tag) return;

    localStorage.setItem(`KTT-ongoing-${this.#tag}`, JSON.stringify(this.#entry));
  }

  // tag with #, e.g. #ktt
  #findSavedEntry(): Entry | undefined {
    if (!this.#tag) return this.#entry;
    const itemKey = `KTT-ongoing-${this.#tag}`;

    const item = localStorage.getItem(itemKey);
    return item ? JSON.parse(item) : this.#entry;
  }

  #clearSavedEntry() {
    if (!this.#tag) return;

    localStorage.removeItem(`KTT-ongoing-${this.#tag}`);
  }
}

customElements.define("entry-ongoing", EntryOngoing);
